export enum SignalrMethods {
  newCaseSubmitted = "newCaseSubmitted",
  newCaseChat = "newCaseChat",
  newAssignUser = "newAssignUser",
  userUnassigned = "userUnassigned",
  updatedCase = "updatedCase",
  movementInRoomDetected = "movementInRoomDetected",
  callLightActivated = "callLightActivated",
  callLightDeactivated = "callLightDeactivated",
  sirenStatusChanged = "sirenStatusChanged",
  interactiveSessionEnded = "interactiveSessionEnded",
  interactiveSessionStarted = "interactiveSessionStarted",
  deviceConnectionChanged = "deviceConnectionChanged",
  devicePowerStatusUpdated = "devicePowerStatusUpdated",
  deviceMicrophonesUpdated = "deviceMicrophonesUpdated",
  deviceSpeakersUpdated = "deviceSpeakersUpdated",
  deviceCamerasUpdated = "deviceCamerasUpdated",
  deviceNetworkInterfacesUpdated = "deviceNetworkInterfacesUpdated",
  deviceStethoscopesUpdated = "deviceStethoscopesUpdated",
  acesoStatusChanged = "acesoStatusChanged",
  caseDataChanged = "caseDataChanged",
  userChanged = "userChanged",
  roomAssignedToDevice = "roomAssignedToDevice",
  roomUnassignedFromDevice = "roomUnassignedFromDevice",
  messageToPatient = "messageToPatient",
  caseStatusChanged = "caseStatusChanged",
  communicationChanged = "communicationChanged",
  pacMessagesAdded = "PacMessagesAdded",
  pacMessagesRemoved = "PacMessagesRemoved",
  safetyCheckUpdated = "safetyCheckUpdated",
  globalAlertNotification = "globalAlertNotification"
}
